import React from 'react';
import {
  ArrowRight,
  BookOpen,
  CreditCard,
  FileCheck,
  FilePlus,
  FileText,
  Landmark,
  PackagePlus,
  Receipt,
  RotateCcw,
  Send,
  ShoppingBag,
  Sparkles,
  Truck,
  UserPlus
} from 'lucide-react';
import { QUICK_ACTIONS_13, QUICK_ACTION_CATEGORIES } from './financeNav';
import './QuickActionsHub.css';

const ACTION_ICONS: Record<string, any> = {
  act_factura_emitida: FileText,
  act_presupuesto: FileCheck,
  act_recibo_venta: Receipt,
  act_nota_credito: RotateCcw,
  act_cobro: CreditCard,
  act_factura_recibida: FilePlus,
  act_gasto: ShoppingBag,
  act_pago_proveedor: Send,
  act_deposito: Landmark,
  act_asiento_manual: BookOpen,
  act_cliente: UserPlus,
  act_proveedor: Truck,
  act_articulo_servicio: PackagePlus
};

interface QuickActionsHubProps {
  onSelectAction: (subScreenId: string) => void;
}

export const QuickActionsHub = ({ onSelectAction }: QuickActionsHubProps) => (
  <div className="qa-hub">
    <div className="qa-hub-header">
      <div>
        <div className="qa-hub-header-top">
          <span className="qa-hub-tag">ACCIONES RÁPIDAS (+ NUEVO)</span>
          <span className="qa-hub-count">{QUICK_ACTIONS_13.length} operaciones clave</span>
        </div>
        <h2 className="qa-hub-title">Catálogo de Creación Rápida</h2>
        <p className="qa-hub-desc">
          Acceso directo a todos los flujos de alta del módulo financiero: ventas comerciales, compras operativas, tesorería, diario y maestros.
        </p>
      </div>
      <div className="qa-hub-module">
        <span className="qa-hub-module-label">Módulo Activo</span>
        <span className="qa-hub-module-name">FINANZAS & CONTABILIDAD</span>
      </div>
    </div>

    {QUICK_ACTION_CATEGORIES.map(cat => {
      const actions = QUICK_ACTIONS_13.filter(a => a.category === cat.key);
      return (
        <div key={cat.key} className="qa-hub-section">
          <div className="qa-hub-section-header">
            <div className="qa-hub-section-left">
              <span className="qa-hub-section-dot" />
              <h3 className="qa-hub-section-title">{cat.label} ({actions.length})</h3>
              <span className="qa-hub-section-desc">— {cat.desc}</span>
            </div>
            <span className="qa-hub-section-badge">{actions.length} disponibles</span>
          </div>

          <div className="qa-hub-grid">
            {actions.map(action => {
              const Icon = ACTION_ICONS[action.id] || Sparkles;
              return (
                <button
                  key={action.id}
                  type="button"
                  onClick={() => onSelectAction(action.subScreenId)}
                  className="qa-hub-card"
                >
                  <div className="qa-hub-card-body">
                    <div className="qa-hub-card-top">
                      <div className="qa-hub-card-icon">
                        <Icon size={18} />
                      </div>
                      <span className="qa-hub-card-badge">{action.badge}</span>
                    </div>
                    <h4 className="qa-hub-card-title">{action.name}</h4>
                    <p className="qa-hub-card-desc">{action.description}</p>
                  </div>
                  <div className="qa-hub-card-footer">
                    <span>Crear ahora</span>
                    <ArrowRight size={12} className="qa-hub-card-arrow" />
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      );
    })}
  </div>
);

export default QuickActionsHub;
